import { render, staticRenderFns } from "./Step5TireInfoMobile.vue?vue&type=template&id=fba296c0&"
import script from "./Step5TireInfoMobile.controller.js?vue&type=script&lang=js&"
export * from "./Step5TireInfoMobile.controller.js?vue&type=script&lang=js&"
import style0 from "./Step5TireInfoMobile.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports